import axios from '../../../axios';
import SearchComLogReq from '../../../types/SearchComLogReq';
import IBulkSmsDTO from '../types/IBulkSmsDTO';
import IBulkUnAssign from '../types/IBulkUnAssign';
import ISendSmsDTO from '../types/ISendSmsDTO';

const url = '/communicationservice/api/communication/';
const bulkUrl = '/communicationservice/api/communication-log/';

const jobCandidateInteractionUrl = '/candidatesearch/api/';

export const getCommunicationServiceAccounts = () => axios.get(url + 'accounts');

export const getSmsLogs = (phoneNumber: string, page: number) =>
  axios.get(`${url}logs/${phoneNumber}/${page}`);

export const getSmsLogsForCandidateid = (candidateId: string) =>
  axios.get(`${jobCandidateInteractionUrl}get-sms-log/${candidateId}`);

export const canSendSms = (phoneNumber: string, fromPhoneNumber: string) =>
  axios.get(`${url}can-send-sms/${phoneNumber}/${fromPhoneNumber}`);

export const sendSms = (payload: ISendSmsDTO) => axios.post(url + 'send-sms', payload);

export const sendBulkSms = (payload: IBulkSmsDTO) =>
  axios.post(`${jobCandidateInteractionUrl}sms-log`, payload);

export const getSMSLogsV2 = (payload: SearchComLogReq) =>
  axios.post(`${jobCandidateInteractionUrl}sms-logs/search`, payload);

export const bulkUnAssign = (payload: IBulkUnAssign) =>
  axios.post(`${bulkUrl}bulk/unAssign`, payload);

export const getCommunicationAccountsForRecruiter = (recruiterId?: string) =>
  axios.get(url + 'accounts', { params: { recruiterId } });

export const getSMSActivityLog = (id: string) => axios.get(`/candidatesearch/api/sms-log/${id}`);
